export default "__VITE_ASSET__4b09f95c__"